module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp3-04-e1a60be6d4eaab7634f88003f3424aee.png";